import { sendErrorLog } from './logClient'
import { ErrorLogSource } from '../@types/errorLog'

export interface ValuationPdfResponse {
  pdfId: string
}

export interface SignedUrlResponse {
  signedPdfUrl: string
}

const delay = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

const createValuationPdf = async (leadId?: string): Promise<ValuationPdfResponse> => {
  console.log('createValuationPdf', leadId)
  if (!leadId) {
    await delay(1000)
    throw new Error(`Failed to read lead id for create valuation pdf request. leadId ${leadId}`)
  }

  try {
    const response = await fetch(`${process.env.RLE_BACKEND_URL}/valuation-pdf?leadId=${leadId}`)
    console.log('response', response)
    if (!response.ok) {
      throw new Error(`${response.status}`)
    }

    await delay(1000)

    return await response.json()
  } catch (error) {
    const errorMessage = `Error while creating valuation pdf, error: ${error.message}`
    sendErrorLog({
      message: errorMessage,
      source: ErrorLogSource.VALUATION_PDF,
    })

    throw new Error(errorMessage)
  }
}

const getSignedUrl = async (leadId?: string, pdfId?: string): Promise<SignedUrlResponse> => {
  if (!leadId || !pdfId) {
    await delay(1000)
    throw new Error(
      `Failed to read lead id or pdf id for signed valuation pdf url request. leadId ${leadId}, pdfId ${pdfId}`
    )
  }

  try {
    const response = await fetch(
      `${process.env.RLE_BACKEND_URL}/signed-valuation-pdf-url?leadId=${leadId}&pdfId=${pdfId}`
    )
    if (!response.ok) {
      throw new Error(`${response.status}`)
    }

    return await response.json()
  } catch (error) {
    const errorMessage = `Error while getting signed valuation pdf url, error: ${error.message}`

    sendErrorLog({
      message: errorMessage,
      source: ErrorLogSource.VALUATION_PDF,
    })

    throw new Error(errorMessage)
  }
}

export { createValuationPdf, getSignedUrl }
